import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';
import { trackClick } from '../services/analytics';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  const handleToggle = () => {
    trackClick('language-toggle', language === 'en' ? 'Switch to Arabic' : 'Switch to English');
    toggleLanguage();
  };

  return (
    <button
      onClick={handleToggle}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#F5F5F7] hover:bg-[#E8E8ED] transition-colors text-sm font-medium text-[#1D1D1F]"
      data-testid="language-toggle"
      aria-label={language === 'en' ? 'Switch to Arabic' : 'Switch to English'}
    >
      <Globe className="w-4 h-4" />
      <span className="text-xs font-inter">
        {language === 'en' ? 'عربي' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageToggle;
